module.exports = __webpack_public_path__ + "img/logotipo-zanoncini-60f97690.png";